import { useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
	operationLoadingModal,
	operationLoadingModalDelayReached,
} from '../recoil-atoms/operation';

export const useLoadingModal = (): {
	tasks: string[];
	addTask: (id: string | string[]) => void;
	removeTask: (id: string | string[]) => void;
} => {
	const minLoadingDelay = 250; // ms
	const opLoadingModal = useRecoilValue(operationLoadingModal);
	const [loadingDelayReached, setLoadingDelayReached] = useRecoilState(
		operationLoadingModalDelayReached,
	);
	const [tasks, setTasks] = useState<string[]>([]);

	const addTask = (id: string | string[]) => {
		const ids: string[] = typeof id === 'string' ? [id] : id;
		const newTasks = tasks.concat(ids.filter((e) => !tasks.includes(e)));

		setTasks(newTasks);
		if (newTasks.length === 1) {
			if (opLoadingModal.showLoading) opLoadingModal.showLoading();
			setLoadingDelayReached(false);
			setTimeout(() => setLoadingDelayReached(true), minLoadingDelay);
		}
	};
	const removeTask = (id: string | string[]) => {
		const ids: string[] = typeof id === 'string' ? [id] : id;
		const newTasks = tasks.filter((e) => !ids.includes(e));

		setTasks(newTasks);
		if (!newTasks.length && loadingDelayReached && opLoadingModal.hideLoading) {
			opLoadingModal.hideLoading();
		}
	};

	return {
		tasks: tasks,
		addTask: addTask,
		removeTask: removeTask,
	};
};
